import { bonda_login_url, url_local, url_desarrollo, url_produccion } from './config';

export const orderList = (lista, sortConfig) => {
    const campo = sortConfig.column;
    const isAsc = sortConfig.direction === 'asc';
    return lista.sort((a, b) => {
        const valA = isNaN(a[campo]) ? a[campo] : Number(a[campo]);
        const valB = isNaN(b[campo]) ? b[campo] : Number(b[campo]);
        if (valA < valB) return isAsc ? -1 : 1;
        if (valA > valB) return isAsc ? 1 : -1;
        return 0;
    });
};

export const iqualsArrays = (a, b) => {
  if (a.length !== b.length) return false;
  const count = {};
  for (const v of a) count[v] = (count[v] || 0) + 1;
  for (const v of b) {
    if (!count[v]) return false;
    count[v]--;
  }
  return true;
}

export const initSortConfig = {
  column: 'Name',
  direction: 'asc',
};

export const initialConfirm = {
  open: false,
  ids: [],
  message: '',
  loading: false,
  error: '',
};

export const interactionSortOptions = [
  { value: 'Name', label: 'Nombre' },
  { value: 'type', label: 'Actividad' },
  { value: 'Score', label: 'Puntaje' },
];

export const contactsSortOptions = [
  { value: 'Name', label: 'Nombre' },
  { value: 'PrincipalEmail', label: 'Email principal' },
  { value: 'AlternativeEmail', label: 'Email alternativo' },
  { value: 'Score', label: 'Puntos' },
  { value: 'Level', label: 'Nivel' },
];

const api_base_url_f = () => {
  switch(process.env.REACT_APP_ENTORNO) { 
      case 'desarrollo':
          return url_desarrollo
      case 'produccion':
          return url_produccion
      default:
          return url_local
  }
}

export const api_base_url = api_base_url_f()

export const getBondaLoginUrl = () => bonda_login_url.trim();

export const openBondaLogin = () => {
  const loginUrl = getBondaLoginUrl();
  if (!loginUrl) return false;
  window.open(loginUrl, '_blank', 'noopener,noreferrer');
  return true;
};

export const handleResponse = async (res, responseType) => {
  try {
    if (res.status === 204) return true;
    if (res.ok) {
        if (responseType === 'json') return await res.json();
        if (responseType === 'blob') return await res.blob();
        if (responseType === 'text') return await res.text();
        return res;
    }
    if (res.status === 401) return 'unauthorized';
    const raw = await res.text();
    let detail = raw;
    try {
      const data = raw ? JSON.parse(raw) : null;
      if (Array.isArray(data?.detail)) {
        detail = data.detail
          .map((item) => item?.msg || item?.message)
          .filter(Boolean)
          .join('. ');
      } else {
        detail = data?.detail || raw;
      }
    } catch {
      detail = raw;
    }
    throw new Error(detail || `Error inesperado: ${res.status}`);
  } catch (e) {
    if (e instanceof Error) throw e;
    return null;
  }
};

export const request = async ({
  url,
  method = 'GET',
  body = null,
  headers = {},
  auth = true,
  responseType = 'json',
  timeoutMs = 20000
}) => {
  const reqHeaders = { ...headers };
  const controller = new AbortController();
  const timeoutId = setTimeout(() => controller.abort(), timeoutMs);
  const options = {
    method,
    headers: reqHeaders,
    credentials: 'include',
    signal: controller.signal
  };
  if (body !== null && body !== undefined) {
    if (body instanceof FormData) {
      options.body = body;
    } else {
      options.body = typeof body === 'string' ? body : JSON.stringify(body);
      if (!reqHeaders['Content-Type']) {
        reqHeaders['Content-Type'] = 'application/json';
      }
    }
  }
  try {
    const res = await fetch(url, options);
    return await handleResponse(res, responseType);
  } catch (e) {
    if (e?.name === 'AbortError')
        throw new Error(`Tiempo de espera agotado al conectar con el servidor: ${url}`);
    if (e instanceof TypeError)
        throw new Error(`No fue posible conectar con el servidor: ${url}`);
    if(e instanceof Error) throw e;
  } finally {
    clearTimeout(timeoutId);
  }
};
